import http from '../http'
export default {
	// mergeUploadFile:(params={})=>http.postQuery('/merge/pdai', params)
}